class BeautyImageToggle extends window.BAO.CustomElement() {
  initialize () {
    super.initialize()

    this.touchstartX = 0
    this.touchendX = 0
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.previous.element,
      'click',
      this.handleLeft.bind(this),
    )
    this.listeners.add(
      this.els.next.element,
      'click',
      this.handleRight.bind(this),
    )
    this.listeners.add(this, 'touchstart', (e) => {
      this.touchstartX = e.changedTouches[0].screenX
    })
    this.listeners.add(this, 'touchend', (e) => {
      this.touchendX = e.changedTouches[0].screenX
      this.checkDirection()
    })
  }

  checkDirection () {
    const threshold = 75

    if (this.touchendX + threshold < this.touchstartX) {
      this.handleRight().bind(this)
    }
    if (this.touchendX > this.touchstartX + threshold) {
      this.handleLeft().bind(this)
    }
  }

  handleRight () {
    this.els.previous.element.disabled = false
    this.els.next.element.disabled = true
    this.els.firstImage.element.ariaHidden = 'true'
    this.els.secondImage.element.ariaHidden = 'false'
  }

  handleLeft () {
    this.els.previous.element.disabled = true
    this.els.next.element.disabled = false
    this.els.firstImage.element.ariaHidden = 'false'
    this.els.secondImage.element.ariaHidden = 'true'
  }
}

if (!customElements.get('beauty-image-toggle')) {
  customElements.define('beauty-image-toggle', BeautyImageToggle)
}
